module.exports = __webpack_public_path__ + "static/media/d2w.0fddf93e.mp4";